module.exports = __webpack_public_path__ + "img/WMZ.3cd6652a.png";